import ModernCompanyHistory from './pages/ModernCompanyHistory';
import QuickContactFloating from './pages/common/QuickContactFloating';

function Root() {
  return (
    <>
      <ModernCompanyHistory />
      <QuickContactFloating />
    </>
  );
}

export default Root;
